/* header-renew.js
 * 1) 検索アイコン → フィールド展開 / 再クリックで送信
 * 2) カテゴリのドロップダウン（キーボード・タッチ補助。マウス hover は CSS 側）
 * 3) SP のスクロール制御
 *      スクロール位置 > 0        → .is-stuck   （position: fixed で追従）
 *      下スクロール              → .is-shrink  （ロゴ縮小・他要素を非表示）
 *      上スクロール              → .is-shrink を解除
 *    PC では何も付けない（圧縮なし）
 */
(function () {
  'use strict';

  var header = document.getElementById('header');
  if (!header) return;

  /* ---------- search ----------
   * PC（hover あり）: 開閉は CSS の :hover / :focus-within が担当。
   *   ここではアイコンのクリック＝検索実行だけを扱う。
   * hover なし端末: 従来どおりクリックで .is-search-open をトグル。
   */
  var toggle = header.querySelector('.js-search-toggle');
  var input = header.querySelector('.js-search-input');
  var form = input ? input.closest('form') : null;
  var canHover = window.matchMedia('(hover: hover)');

  function closeSearch() {
    header.classList.remove('is-search-open');
    toggle.setAttribute('aria-expanded', 'false');
    if (document.activeElement === input) input.blur();
  }

  if (toggle && input && form) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();

      if (input.value.trim() !== '') {
        form.submit();
        return;
      }

      if (canHover.matches) {
        input.focus();                       // 開いた状態で入力へ移動
      } else if (!header.classList.contains('is-search-open')) {
        header.classList.add('is-search-open');
        toggle.setAttribute('aria-expanded', 'true');
        input.focus();
      } else {
        closeSearch();
      }
    });

    // hover なし端末で、フォームの外をタップしたら閉じる
    document.addEventListener('click', function (e) {
      if (!header.classList.contains('is-search-open')) return;
      if (!form.contains(e.target)) closeSearch();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (header.classList.contains('is-search-open') || document.activeElement === input) {
        closeSearch();
        toggle.focus();
      }
    });

    input.addEventListener('focus', function () {
      toggle.setAttribute('aria-expanded', 'true');
    });
    input.addEventListener('blur', function () {
      if (!header.classList.contains('is-search-open')) {
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ---------- category dropdown ---------- */
  var items = header.querySelectorAll('.header-cat__item.has-child');

  Array.prototype.forEach.call(items, function (item) {
    var link = item.querySelector('.header-cat__link');

    // タッチ端末では 1 度目のタップでパネルを開く
    item.addEventListener('click', function (e) {
      if (!window.matchMedia('(hover: none)').matches) return;
      if (e.target !== link) return;
      if (!item.classList.contains('is-open')) {
        e.preventDefault();
        Array.prototype.forEach.call(items, function (o) { o.classList.remove('is-open'); });
        item.classList.add('is-open');
        link.setAttribute('aria-expanded', 'true');
      }
    });

    item.addEventListener('focusin', function () { link.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('focusout', function () {
      if (!item.contains(document.activeElement)) link.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('click', function (e) {
    Array.prototype.forEach.call(items, function (item) {
      if (!item.contains(e.target)) {
        item.classList.remove('is-open');
        var l = item.querySelector('.header-cat__link');
        if (l) l.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* ---------- scroll ----------
   * 追従（.is-stuck）: PC / SP 共通
   *   #shopify-section-header-attention があれば、その高さを超えてから
   *   無ければ常時追従
   * 縮小（.is-shrink）: SP のみ。下スクロールで付与、上スクロールで解除
   */
  var SP = window.matchMedia('screen and (max-width: 767px)');
  var attention = document.getElementById('shopify-section-header-attention');
  var SHRINK_FROM = 60;   // ここより上では縮小しない
  var DOWN_STEP = 2;      // 下スクロール判定。参考サイトは即座に隠れるので小さめ
  var UP_STEP = 12;       // 上スクロール判定。慣性の揺り戻しで誤爆しない程度
  var lastY = window.pageYOffset || 0;
  var stickFrom = 0;
  var ticking = false;

  function measure() {
    stickFrom = attention ? attention.offsetHeight : 0;
  }

  function update() {
    ticking = false;

    var y = window.pageYOffset || 0;
    if (y < 0) y = 0;

    // --- 追従 ---
    header.classList.toggle('is-stuck', !attention || y > stickFrom);

    // --- 縮小（SP のみ）---
    if (!SP.matches) {
      header.classList.remove('is-shrink');
      lastY = y;
      return;
    }

    // ドロワーが開いている間は縮小しない
    if (header.classList.contains('is-open')) {
      header.classList.remove('is-shrink');
      lastY = y;
      return;
    }

    var diff = y - lastY;

    if (diff >= DOWN_STEP && y > SHRINK_FROM) {
      header.classList.add('is-shrink');       // 下スクロール
      lastY = y;
    } else if (diff <= -UP_STEP) {
      header.classList.remove('is-shrink');    // 上スクロール
      lastY = y;
    } else if (diff > 0) {
      lastY = y;                               // 下方向は基準を追従させる
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  function onResize() {
    measure();
    onScroll();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onResize);
  window.addEventListener('load', onResize);
  if (SP.addEventListener) {
    SP.addEventListener('change', onResize);
  } else if (SP.addListener) {
    SP.addListener(onResize);
  }

  // attention バーはスライダーで高さが変わることがあるので監視
  if (attention && window.ResizeObserver) {
    new ResizeObserver(onResize).observe(attention);
  }

  measure();

  // ドロワーの開閉に追従させる
  var spMenuBtns = document.querySelectorAll('.js-sp-menu');
  Array.prototype.forEach.call(spMenuBtns, function (btn) {
    btn.addEventListener('click', function () {
      window.setTimeout(function () {
        lastY = window.pageYOffset || 0;
        update();
      }, 0);
    });
  });

  update();
})();
